// Notification center (UC-17). Lists worker-generated notifications and marks read.

import $ from 'jquery';
import type { AppNotification } from '@shared/models';
import type { Screen } from './types';
import { api } from '../api';
import { refreshUnread } from '../session';
import { esc } from '../ui/dom';
import { emptyHtml, loadingHtml } from '../ui/states';

const ICON: Record<AppNotification['topic'], string> = {
  joined: '✅',
  left: '↩️',
  invited: '✉️',
  'invite-accepted': '🎉',
  'join-request': '🙋',
  'request-accepted': '🎉',
  'request-declined': '🚫',
  'friend-request': '👋',
  'friend-accepted': '🤝',
  'game-edited': '✏️',
  'game-cancelled': '❌',
  'game-approaching': '⏰',
  'players-missing': '🔍',
};

export const NotificationsScreen: Screen = async (body) => {
  body.html(loadingHtml());
  const list = await api.call('notifications.list', undefined);

  if (list.length === 0) {
    body.html(emptyHtml('🔔', 'Henüz bildirim yok.'));
    await api.call('notifications.markAllRead', undefined);
    void refreshUnread();
    return;
  }

  // Friend notifications deep-link to Çevrem; game ones to the game detail.
  const hrefFor = (n: AppNotification): string =>
    n.topic.startsWith('friend') ? '#/friends' : n.gameId ? `#/game/${n.gameId}` : '';
  const rows = list
    .map(
      (n) => `
      <div class="notif ${n.read ? '' : 'is-unread'}" data-href="${esc(hrefFor(n))}">
        <span class="notif__icon">${ICON[n.topic] ?? '🔔'}</span>
        <span class="notif__msg">${esc(n.message)}</span>
      </div>`,
    )
    .join('');
  body.html(`<div class="notif-list">${rows}</div>`);

  body.on('click', '.notif', function () {
    const href = $(this).data('href') as string;
    if (href) location.hash = href;
  });

  // Opening the center marks everything read.
  await api.call('notifications.markAllRead', undefined);
  void refreshUnread();
};
